var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoveUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2785_384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0518 3.02828L10.0521 3.02805C11.6589 1.37004 14.2261 1.13172 15.9286 2.58226C17.9138 4.27662 18.02 7.32465 16.2386 9.16299L16.2385 9.16309L9.43589 16.1872C9.43585 16.1872 9.43582 16.1873 9.43579 16.1873C9.19282 16.4379 8.80453 16.4379 8.56156 16.1873C8.56152 16.1873 8.56149 16.1872 8.56146 16.1872L1.75903 9.1633C-0.0191734 7.32498 0.0870512 4.27681 2.07215 2.58238C3.7748 1.13154 6.34534 1.37028 7.94846 3.02769L7.94904 3.02828L8.64161 3.74196L9.00043 4.1117L9.35925 3.74196L10.0518 3.02828Z",
    stroke: "#646464"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2785_384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveUser);
export default __webpack_public_path__ + "static/media/Love_user.cc77e481d79c10bbf8a0a857d0842a14.svg";
export { ForwardRef as ReactComponent };